import styled from 'styled-components';

import {
  Input,
  Radio,
  SearchInput,
  TransparentButton,
  Typography,
} from '@libs/components';

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  padding: 2rem 2rem;
  ${({ theme }) => theme.media.tablet`
  padding: 2rem 3.6rem 3.6rem 3.6rem;

  `};
`;

export const EditWrapper = styled(TransparentButton)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 2.4rem 0 1.6rem;
`;
export const EditIconWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: 0.4rem;
`;

export const AddressOption = styled(Radio)`
  border-radius: 0;
  border: unset;
  padding: 1.6rem;
  height: unset;
  min-height: 7.5rem;

  :hover {
    background-color: ${({ theme }) => theme.colors.interactive.secondary};
  }

  background-color: ${({ theme, checked }) =>
    checked
      ? theme.colors.interactive.secondary
      : theme.colors.surface.default};

  .description-text {
    word-break: break-word;
  }
`;

export const OptionsWrapper = styled.div`
  margin-bottom: 1.2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  border-radius: ${({ theme }) => theme.borderRadius.x4};
  border: 0.1rem solid ${({ theme }) => theme.colors.borders.default};
  width: 100%;

  ${AddressOption} {
    border-bottom: 1px solid ${({ theme }) => theme.colors.borders.default};
  }
  ${AddressOption}:first-child {
    border-top-left-radius: ${({ theme }) => theme.borderRadius.mediumHigh};
  }
  ${AddressOption}:last-child {
    border-top-left-radius: unset;
    border-bottom: none;
  }
`;

export const PlusIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 3.8rem;
  height: 3.8rem;
  border-radius: ${({ theme }) => theme.borderRadius.x9};
  padding: 0.7rem;
  background-color: ${({ theme }) => theme.colors.surface.tertiary};
`;

export const InputsWrapper = styled.div`
  display: flex;
  flex-direction: column;

  gap: 1.6rem;
  margin-bottom: 3.2rem;
  margin-top: 1rem;
`;

export const AddressMemoInput = styled(Input)`
  border-radius: ${({ theme }) => theme.borderRadius.x3};
`;

export const SelectSearchInputWrapper = styled.div`
  width: 100%;
  padding: 0 2rem;
  margin-bottom: 2rem;

  ${({ theme }) => theme.media.laptop`
  padding: 0 3.2rem;

  width:50rem;
  `}
`;

export const CustomSearchInput = styled(SearchInput)`
  border-radius: ${({ theme }) => theme.borderRadius.x8};
  width: 100%;
`;

export const SelectRenderItemWrapper = styled.div`
  width: 100%;
  padding: 0 2rem;
  ${({ theme }) => theme.media.laptop`
  padding: 0 3.2rem;

  `}
  margin-top: 1.6rem;
  margin-bottom: 1.6rem;

  &:first-child {
    margin-top: 0;
  }
`;

export const CustomTypography = styled(Typography)`
  text-align: start;
`;

export const TitleTypography = styled(Typography)`
  margin-bottom: 2rem;
`;

export const Line = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.colors.borders.default};
  margin: 2rem 0;
`;
